import { SectionEditView, SectionCreateView } from './views';
import BusinessIcon from '@material-ui/icons/Business';

export default {
  edit: SectionEditView,
  create: SectionCreateView,
  icon: BusinessIcon,
};
